import {Chip} from '@ds/components';

import {PRO_STATUS_CONFIG} from '../../../constants';

type ProStatusProps = {
  value?: string;
};

const ProStatus: React.FC<ProStatusProps> = ({value}) => {
  const status = value ? PRO_STATUS_CONFIG[value] : undefined;

  return (
    <Chip
      label={status?.label ?? value ?? ''}
      variant="soft"
      color={status?.color ?? 'default'}
      size="sm"
      interactive={false}
    />
  );
};

export default ProStatus;
